import {createUseStyles} from 'react-jss';
import color from 'color';

/**
 * @param size (optional)
 * Can be one of {"small", "extra-small"}. Defaults to a medium-sized spinner
 * More sizes can be added
 *
 * @returns A spinner component, purely in CSS
 *
 * Example usage: <Spinner />
 * Or with size property: <Spinner size="small" />
 * and don't forget to import the Spinner
 */

const defaultBorderWidth = '1.1em';
const defaultDimension = '10em';

function resize(scaleFactor) {
  return {
    borderWidth: `${parseFloat(defaultBorderWidth) * scaleFactor}em`,
    width: `${parseFloat(defaultDimension) * scaleFactor}em`,
    height: `${parseFloat(defaultDimension) * scaleFactor}em`,
  };
}

const defaultAttribute = {
  borderRadius: '50%',
  width: defaultDimension,
  height: defaultDimension,
};

export default createUseStyles({
  spinner: {
    fontSize: 10,
    position: 'relative',
    textIndent: '-9999em',
    transform: 'translateZ(0)',
    animation: '$load8 1.1s infinite linear',
    display: 'inline-block',
    border: props => `${defaultBorderWidth} solid ${color(props.theme.base.color).alpha(0.2)}`,
    borderLeftColor: props => props.theme.base.color,
    extend: props => ({
      ...defaultAttribute,
      ...(props.size === 'small') && resize(0.4),
      ...(props.size === 'extra-small') && resize(0.2),
      ...(props.size === 'radio') && resize(0.15),
    }),
  
    // Don't forget to set the width and height of the containing div, or use
    // `.(Parent-class-name) .Spinner` as your selector to override this
    // width and height directly.
    '&:after': {
      ...defaultAttribute,
    },
  },
  
  '@keyframes load8': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
});
